var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoRemoteConn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.4501 69.8601L20.3301 61.5301L20.2401 61.4701C17.6501 59.9801 14.4201 60.4201 11.8201 61.9201C9.22005 63.4201 8.25005 65.4001 10.8201 66.9201L25.1001 75.2901C25.1001 75.2901 28.8001 76.9801 33.2001 74.4401C33.2001 74.4401 37.7101 71.7501 34.4501 69.8601Z",
    fill: "url(#paint0_linear_3890_385976)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6801 54.81C37.6801 46.77 32.0401 37 25.0801 32.98C21.5701 30.95 18.3901 30.78 16.1001 32.14L10.0601 35.63L12.4801 39.95C12.4801 40.05 12.4801 40.15 12.4801 40.25C12.4801 48.16 17.9501 57.75 24.7701 61.88L27.4801 66.72L33.9501 62.99C36.2601 61.68 37.6901 58.85 37.6901 54.8L37.6801 54.81Z",
    fill: "url(#paint1_linear_3890_385976)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.627 66.6418C32.5487 63.8003 32.5493 54.5874 27.6284 46.0642C22.7076 37.541 14.7287 32.9351 9.80703 35.7766C4.8854 38.6181 4.88477 47.831 9.80563 56.3542C14.7265 64.8774 22.7054 69.4833 27.627 66.6418Z",
    fill: "url(#paint2_linear_3890_385976)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.677 64.9963C31.0725 62.4586 31.072 54.2286 26.6758 46.6142C22.2796 38.9998 15.1525 34.8843 10.757 37.4221C6.36148 39.9598 6.36203 48.1898 10.7582 55.8042C15.1544 63.4186 22.2815 67.5341 26.677 64.9963Z",
    fill: "#EDECED"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6901 66.61L27.5701 66.68C27.5701 66.68 27.6501 66.63 27.6901 66.61Z",
    fill: "#9D9D9D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.48 65.05C24.56 65.66 22.15 65.3 19.54 63.79C13.28 60.18 8.20998 51.4 8.20998 44.17C8.20998 40.93 9.22998 38.56 10.92 37.25C10.98 37.2 11.05 37.15 11.11 37.11C11.04 37.14 10.97 37.18 10.9 37.22C8.70998 38.34 7.34998 40.93 7.34998 44.67C7.34998 51.89 12.42 60.68 18.68 64.29C21.74 66.06 24.51 66.25 26.55 65.16C26.74 65.06 26.93 64.94 27.11 64.81C26.91 64.9 26.7 64.98 26.49 65.05H26.48Z",
    fill: "url(#paint3_linear_3890_385976)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.54 63.79C13.28 60.18 8.20998 51.4 8.20998 44.17C8.20998 40.93 9.22998 38.56 10.92 37.25C10.98 37.2 11.05 37.15 11.11 37.11C11.04 37.14 10.97 37.18 10.9 37.22C8.70998 38.34 7.34998 40.93 7.34998 44.67C7.34998 51.89 12.42 60.68 18.68 64.29C21.74 66.06 24.51 66.25 26.55 65.16C26.74 65.06 26.93 64.94 27.11 64.81C26.91 64.9 26.7 64.98 26.49 65.05C24.57 65.66 22.16 65.3 19.55 63.79H19.54Z",
    fill: "url(#paint4_linear_3890_385976)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M31.04 45.6C30.68 45.42 30.33 45.07 30.06 44.61C29.56 43.74 29.57 42.79 30.09 42.5L57.99 26.38C58.51 26.08 59.33 26.55 59.83 27.42C60.33 28.29 60.32 29.24 59.8 29.53L31.9 45.65C31.66 45.79 31.35 45.76 31.04 45.6Z",
    fill: "#D6D6D6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M73.88 33.9201C73.88 25.8801 68.24 16.1101 61.28 12.0901C57.77 10.0601 54.59 9.89008 52.3 11.2501L46.26 14.7401L48.68 19.0601C48.68 19.1601 48.68 19.2601 48.68 19.3601C48.68 27.2701 54.15 36.8601 60.97 40.9901L63.68 45.8301L70.15 42.1001C72.46 40.7901 73.89 37.9601 73.89 33.9101L73.88 33.9201Z",
    fill: "url(#paint5_linear_3890_385976)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8271 45.7419C68.7487 42.9004 68.7494 33.6875 63.8285 25.1643C58.9076 16.6411 50.9287 12.0352 46.0071 14.8767C41.0855 17.7182 41.0848 26.9311 46.0057 35.4543C50.9266 43.9775 58.9055 48.5834 63.8271 45.7419Z",
    fill: "url(#paint6_linear_3890_385976)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8771 44.0964C67.2726 41.5587 67.272 33.3287 62.8758 25.7143C58.4797 18.0999 51.3526 13.9844 46.9571 16.5222C42.5616 19.0599 42.5621 27.2899 46.9583 34.9043C51.3545 42.5187 58.4816 46.6342 62.8771 44.0964Z",
    fill: "#EDECED"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M63.89 45.7101L63.77 45.7801C63.77 45.7801 63.85 45.7301 63.89 45.7101Z",
    fill: "#9D9D9D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M62.68 44.16C60.76 44.77 58.3501 44.41 55.7401 42.9C49.4801 39.29 44.41 30.51 44.41 23.28C44.41 20.04 45.43 17.67 47.12 16.36C47.18 16.31 47.2501 16.26 47.3101 16.22C47.2401 16.25 47.17 16.29 47.1 16.33C44.91 17.45 43.55 20.04 43.55 23.78C43.55 31 48.6201 39.79 54.8801 43.4C57.9401 45.17 60.71 45.36 62.75 44.27C62.9401 44.17 63.1301 44.05 63.3101 43.92C63.1101 44.01 62.9 44.09 62.69 44.16H62.68Z",
    fill: "url(#paint7_linear_3890_385976)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7401 42.9C49.4801 39.29 44.41 30.51 44.41 23.28C44.41 20.04 45.43 17.67 47.12 16.36C47.18 16.31 47.2501 16.26 47.3101 16.22C47.2401 16.25 47.17 16.29 47.1 16.33C44.91 17.45 43.55 20.04 43.55 23.78C43.55 31 48.6201 39.79 54.8801 43.4C57.9401 45.17 60.71 45.36 62.75 44.27C62.9401 44.17 63.1301 44.05 63.3101 43.92C63.1101 44.01 62.9 44.09 62.69 44.16C60.77 44.77 58.36 44.41 55.75 42.9H55.7401Z",
    fill: "url(#paint8_linear_3890_385976)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3890_385976",
    x1: 13.8501,
    y1: 73.1801,
    x2: 31.1001,
    y2: 63.2201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#565656",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#171717",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3890_385976",
    x1: 16.2101,
    y1: 60.22,
    x2: 30.2201,
    y2: 35.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9B8B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#B1B0B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#A5A6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#9E9F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#9D9E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3890_385976",
    x1: 6.11401,
    y1: 51.21,
    x2: 31.324,
    y2: 51.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B9B8B9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3890_385976",
    x1: 7.34998,
    y1: 51.48,
    x2: 27.1,
    y2: 51.48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E3E3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9D9D9D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3890_385976",
    x1: 7.34998,
    y1: 51.48,
    x2: 27.1,
    y2: 51.48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9B8B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3890_385976",
    x1: 52.4,
    y1: 39.3301,
    x2: 66.42,
    y2: 15.0601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9B8B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#B1B0B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#A5A6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#9E9F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#9D9E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3890_385976",
    x1: 42.3142,
    y1: 30.3101,
    x2: 67.5142,
    y2: 30.3101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B9B8B9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3890_385976",
    x1: 43.54,
    y1: 30.58,
    x2: 63.3001,
    y2: 30.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E3E3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9D9D9D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3890_385976",
    x1: 43.54,
    y1: 30.58,
    x2: 63.3001,
    y2: 30.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9B8B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6D6D6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoRemoteConn);
export default __webpack_public_path__ + "static/media/no_remote_conn.92c28c0a90bc9f7dc3a658201db4db6a.svg";
export { ForwardRef as ReactComponent };